import { render, staticRenderFns } from "./DragDropSimple.vue?vue&type=template&id=6cd30b7e"
import script from "./DragDropSimple.vue?vue&type=script&lang=js"
export * from "./DragDropSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports